import { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';

const ImageCarousel = (props) => {
    const [message, setMessage] = useState('Loading images...')
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        if (props?.data == '' || props?.data == null) {
            setTimeout(() => {
                setMessage("No Images Found")
            }, 2000);
        }
        else
            setMessage('Loading images...')
    }, [props])
    const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };
    return (
        <div id='custom-carousel'>
            {props?.data?.length > 0 ? (
                <div>
                <Carousel controls={props.data.length > 1} indicators={props.data.length > 1} interval={null} activeIndex={activeIndex} onSelect={handleSelect}
                    prevIcon={<span className="custom-prev-icon">‹</span>}
                    nextIcon={<span className="custom-next-icon">›</span>}>
                    {props.data.map((src, index) => (
                        <Carousel.Item key={index}>
                            <img
                                src={src}
                                alt={`Slide ${index}`}
                                className="d-block"
                                style={{ maxWidth: "40vw", maxHeight: "350px", minWidth: "10vw", minHeight: "180px" }}
                            />
                        </Carousel.Item>
                    ))}
                    </Carousel>
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                        {props.data.length > 0 && `${activeIndex + 1} / ${props.data.length}`}
                    </div>
                </div>
                
            ) : (
                <label className="d-block w-100">{message}</label>
            )}
        </div>
    )
}
export default ImageCarousel